
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { AccountDetailViewModel, BudgetFundSearchCriteria, ExecutionResult, IBudgetAmounts } from "@tylertech/tyler-api-types";

/**
 * BudgetFundService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class BudgetFundService {
    private readonly $apiService = inject(ApiService);
    
    GetAccountDetail(pFundSearchViewModel: BudgetFundSearchCriteria): Promise<ExecutionResult<AccountDetailViewModel[]>> {
        return this.$apiService.sendAuth("IBudgetFundService/GetAccountDetail", pFundSearchViewModel);
    }
    GetChartBudgetData(pFundSearchViewModel: BudgetFundSearchCriteria): Promise<ExecutionResult<IBudgetAmounts[]>> {
        return this.$apiService.sendAuth("IBudgetFundService/GetChartBudgetData", pFundSearchViewModel);
    }
}
